var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-control custom-switch"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":_vm.inputId},domProps:{"checked":_vm.value ? "checked" : null},on:{"input":_vm.handleInput}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }